import type React from "react";
import {memo, useCallback, useState} from "react";

import type {Bed} from "../type";

import BedForm from "./BedForm";
import BedName from "./BedName";

import {TableCell, TableRow} from "@/client/components/Table";
import TableCellEditRemoveActions from "@/client/components/Table/TableCellEditRemoveActions";

type Props = {
    bed: Bed;
    index: number;
    onChange: (bed: Bed, index?: number) => void;
    onRemove: (index: number) => void;
};

const BedItem: React.FC<Props> = ({bed, index, onChange, onRemove}) => {
    const [isEdit, setIsEdit] = useState<boolean>();

    const onToggle = useCallback(() => {
        setIsEdit(prev => !prev);
    }, []);

    const handleChange = useCallback(
        (bed: Bed, index?: number) => {
            onChange(bed, index);
            setIsEdit(false);
        },
        [onChange]
    );

    return isEdit ? (
        <BedForm bed={bed} index={index} onCancel={onToggle} onChange={handleChange} />
    ) : (
        <TableRow>
            <TableCell>
                <BedName bed={bed} />
            </TableCell>
            <TableCell>{bed.count}</TableCell>
            <TableCell align="end">
                <TableCellEditRemoveActions
                    id={index}
                    item={bed}
                    onEdit={onToggle}
                    onRemove={onRemove}
                />
            </TableCell>
        </TableRow>
    );
};

export default memo(BedItem);
